import styled, { css } from 'styled-components';

export const PopeyePromotionsList = styled.div`
  font-size: 14px;
  max-height: 116px;
  margin-bottom: 6px;
`;

export const PopeyePromotionItem = styled.div`
  display: flex;
  margin-bottom: 4px;
  white-space: nowrap;
`;

export const PromotionType = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 25px;
  padding: 0 8px;
  color: #ffffff;
  font-weight: bold;
  background-color: ${props => props.promotionColor};
  margin-right: 8px;
`;

export const PromotionDates = styled.span`
  font-size: 14px;
  color: #333333;
`;